import templateUrl from "emun.auth/register-consumer-fieldset.htm";

export default {
  templateUrl,
  bindings: {
    request: "<ngModel",
  },
  controller() {},
};
